export default __webpack_public_path__ + "static/media/popupExitIcon.8266abd7.svg";